/* Maison de l'Amour - pochette offerte au-dela d'un seuil de panier (+ bijou offert du 8 au 15/11 si configuré).
   FICHIER DE RÉFÉRENCE (04/11) : broadcast8/fix-cadeau-2026-11-04/mda-gift.js, copié tel quel dans chaque thème.
   Se branche sur le hook cadeau natif de Broadcast 8 (GWP_CART_DRAWER_CONFIG) :
   le theme attend que gwpProcessed repasse a true avant de redessiner le tiroir,
   ce qui evite le clignotement "pas de cadeau" puis "cadeau".
   Config posee par snippets/mda-gift-init.liquid dans window.MDA_GIFT. */
(function () {
  'use strict';

  var cfg = window.MDA_GIFT;
  if (!cfg || !cfg.enabled || !cfg.variants || !cfg.variants.length) return;

  var ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
  var KEY = 'mda_gift_variant';
  var busy = false;
  var cart = null;

  // Le theme differe la reconstruction du tiroir tant qu'un module cadeau est declare.
  window.GWP_CART_DRAWER_CONFIG = window.GWP_CART_DRAWER_CONFIG || { source: 'mda-gift' };
  window.PresidioPlus = window.PresidioPlus || {};
  if (typeof window.PresidioPlus.gwpProcessed === 'undefined') window.PresidioPlus.gwpProcessed = true;

  var IDS = {};
  cfg.variants.forEach(function (v) { IDS[String(v.id)] = 1; });
  if (cfg.defaultVariantId) IDS[String(cfg.defaultVariantId)] = 1;

  /* MDA 02/11 : offre bijou offert : second cadeau (bijou offert du 8 au 15/11) réconcilié dans le MÊME passage
     que la trousse (un seul verrou « busy », une seule mise à jour du panier). Actif seulement si
     window.mdaOffre.on (snippets/mda-offre-etat.liquid). Seuil après remise, comme la trousse. */
  var C2 = cfg.cadeau2 || null;
  function isGift2(id) { return !!(C2 && String(id) === String(C2.variantId)); }
  function offreOn() { return !!(C2 && window.mdaOffre && window.mdaOffre.on); }
  /* MDA 04/11 : une ligne marquée « bijou offert » (_mda_cadeau = bijou) est reconnue MÊME sans la config de l'offre
     (autre thème, offre terminée, réglage coupé) : hors offre active, elle est retirée. Ex. panier fait le 15/11,
     cliente revenue le 16/11 : plus de bague offerte. */
  function isBijou(it) { return !!((it.properties && it.properties._mda_cadeau === 'bijou') || isGift2(it.variant_id)); }
  function gift2Lines() {
    var out = [];
    if (!cart) return out;
    for (var i = 0; i < cart.items.length; i++) if (isBijou(cart.items[i])) out.push(cart.items[i]);
    return out;
  }
  function seuil2() {
    var r = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
    return Math.round(C2.threshold * r);
  }

  function drawerEl() { return document.querySelector('cart-drawer'); }

  function drawerIsOpen() {
    var d = drawerEl();
    return !!(d && d.classList.contains('is-open'));
  }

  /* Ajouter la pochette passe par /cart/add.js, et un app embed du panier ouvre le
     tiroir sur cet appel. Quand on ajoute le cadeau au chargement d'une page, la
     cliente n'a rien demande : on restaure l'etat du tiroir tel qu'il etait. */
  function closeDrawer() {
    var d = drawerEl();
    if (!d) return;
    var btn = d.querySelector('[data-cart-drawer-close], .drawer__close, [data-drawer-close]');
    if (btn) {
      btn.click();
    } else {
      d.classList.remove('is-open');
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
    }
  }

  function restoreDrawer(wasOpen) {
    if (wasOpen) return;
    [200, 700, 1400].forEach(function (ms) {
      setTimeout(function () { if (drawerIsOpen()) closeDrawer(); }, ms);
    });
  }

  function isGift(id) { return !!IDS[String(id)]; }

  function url(p) { return ROOT + p; }

  function post(path, body) {
    return fetch(url(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-MDA-Gift': '1' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  // MDA 04/11 : lecture fraîche pour la réconciliation (jamais le cache de mdaPanier ni une lecture déjà en vol)
  function frais() {
    return fetch(url('/cart.js?mda_gift=' + Date.now()), { headers: { 'X-MDA-Gift': '1' }, cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  function getCart() {
    if (window.mdaPanier) return window.mdaPanier();
    return fetch(url('/cart.js'), { headers: { 'X-MDA-Gift': '1' } }).then(function (r) { return r.json(); });
  }

  function chosenId() {
    try {
      var v = sessionStorage.getItem(KEY);
      if (v && IDS[v]) return Number(v);
    } catch (e) {}
    return cfg.defaultVariantId;
  }

  function remember(id) {
    try { sessionStorage.setItem(KEY, String(id)); } catch (e) {}
  }

  /* Le produit cadeau a plusieurs couleurs : le panier peut porter PLUSIEURS lignes
     cadeau. On les collecte toutes. Ne jamais se contenter de la premiere : c'est ce
     qui a laisse passer deux pochettes sur la commande #10644 du 22/09. */
  function giftLines() {
    var out = [];
    if (!cart) return out;
    for (var i = 0; i < cart.items.length; i++) {
      if (isGift(cart.items[i].variant_id)) out.push(cart.items[i]);
    }
    return out;
  }

  function giftLine() {
    var l = giftLines();
    return l.length ? l[0] : null;
  }

  /* Seuil calcule sur le total APRES reductions, ligne cadeau exclue.
     Decision Jordan du 02/08/2026 : un code promo qui fait repasser sous le seuil
     retire la pochette (protection de la marge). Ne pas changer sans son accord. */
  /* Seuil reglé en euros : converti dans la devise de la cliente (ex. 99 € = ~740 kr).
     Sans conversion, 138 kr passaient pour 138 € (commande #11064, 25/10/2026). */
  function seuil() {
    var r = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
    return Math.round(cfg.threshold * r);
  }

  function eligibleTotal() {
    if (!cart) return 0;
    var t = cart.total_price;
    var lines = giftLines();
    for (var i = 0; i < lines.length; i++) t -= lines[i].final_line_price;
    gift2Lines().forEach(function (l) { t -= l.final_line_price; }); // MDA 02/11 : offre bijou offert
    // carte cadeau (dématérialisée) : hors seuil de la trousse
    if (cfg.sansCarteCadeau !== false) (cart.items || []).forEach(function (it) { if (it.gift_card) t -= it.final_line_price; });
    return t;
  }

  /* Ajoute, retire ou plafonne la pochette. Toujours une seule, quantite 1.
     Le retrait cible la variante REELLEMENT au panier, pas celle reglee dans le
     theme : sinon une cliente ayant choisi une autre couleur garderait sa pochette. */
  /* silent = true : on ajoute le cadeau sans que la cliente ait touche au panier
     (chargement de page). Dans ce cas on remet le tiroir dans l'etat ou il etait.
     Sur une vraie action panier, le tiroir doit rester ouvert : pas de restauration. */
  /* Remet les lignes cadeau dans l'etat voulu, en un seul /cart/update.js :
       - sous le seuil          : toutes les lignes cadeau a 0
       - au-dessus du seuil     : une seule ligne, quantite 1, les autres a 0
       - couleur voulue absente : les autres a 0, puis ajout de la bonne
     forcedId = couleur demandee par la cliente. Sans forcedId on garde la couleur deja
     au panier, pour ne rien changer dans son dos. */
  /* MDA 02/11 : offre bijou offert : passages mis en file. L'offre déclenche un passage de plus au chargement :
     deux passages simultanés lisaient le même panier et ajoutaient le cadeau deux fois. */
  var fileSync = Promise.resolve();
  function sync(silent, forcedId) {
    var p = fileSync.then(function () { return sync0(silent, forcedId); });
    fileSync = p.catch(function () {});
    return p;
  }
  function sync0(silent, forcedId) {
    if (busy) return Promise.resolve(false);
    return frais().then(function (c) {
      cart = c;
      var lines = giftLines();
      var ok = eligibleTotal() >= seuil();
      var updates = {};
      var addId = null;
      var i;

      if (ok) {
        var wanted = forcedId || (lines.length ? lines[0].variant_id : chosenId());
        var present = false;
        // MDA 04/11 : clé de ligne + une seule ligne gardée, même si la même variante est au panier deux fois
        for (i = 0; i < lines.length; i++) {
          var keep = !present && String(lines[i].variant_id) === String(wanted);
          if (keep) present = true;
          updates[lines[i].key] = keep ? 1 : 0;
        }
        if (!present) addId = wanted;
      } else {
        for (i = 0; i < lines.length; i++) updates[lines[i].key] = 0;
      }
      // MDA 02/11 : offre bijou offert : une seule ligne, quantité 1, pendant l'offre et au-dessus du seuil
      var lines2 = gift2Lines(), add2 = null;
      var ok2 = offreOn() && eligibleTotal() >= seuil2();
      // MDA 04/11 : on garde la seule ligne marquée « cadeau » (_mda_cadeau = bijou) ; une bague ajoutée à la main
      // (sans marque) est retirée et remplacée par une ligne cadeau, jamais deux bagues
      var garde2 = -1;
      for (i = 0; i < lines2.length; i++) if (garde2 < 0 && lines2[i].properties && lines2[i].properties._mda_cadeau === 'bijou') garde2 = i;
      for (i = 0; i < lines2.length; i++) updates[lines2[i].key] = (ok2 && i === garde2) ? 1 : 0;
      if (ok2 && garde2 < 0 && C2) add2 = C2.variantId;

      var aFaire = !!addId || !!add2;
      for (i = 0; i < lines2.length; i++) {
        if (lines2[i].quantity !== updates[lines2[i].key]) aFaire = true;
      }
      for (i = 0; i < lines.length; i++) {
        if (lines[i].quantity !== updates[lines[i].key]) aFaire = true;
      }
      if (!aFaire) return false;

      busy = true;
      var wasOpen = silent ? drawerIsOpen() : true;
      var chain = Promise.resolve();
      if (lines.length || lines2.length) {
        chain = chain.then(function () { return post('/cart/update.js', { updates: updates }); });
      }
      var ajouts = [];
      if (addId) ajouts.push({ id: addId, quantity: 1, properties: { _mda_gift: '1' } });
      if (add2) ajouts.push({ id: add2, quantity: 1, properties: { _mda_gift: '1', _mda_cadeau: 'bijou' } });
      // MDA 04/11 : un appel par cadeau (un bijou en rupture faisait échouer l'ajout de la trousse dans le même appel)
      ajouts.forEach(function (a) {
        chain = chain.then(function () { return post('/cart/add.js', { items: [a] }); }).catch(function (e) { console.warn('[mda-gift]', e); });
      });
      return chain
        .then(function () { return frais(); })
        .then(function (c2) { cart = c2; })
        .catch(function (e) { console.warn('[mda-gift]', e); })
        .then(function () {
          busy = false;
          restoreDrawer(wasOpen);
          return true;
        });
    });
  }

  /* Changement de couleur : une seule passe de reconciliation, plus de
     « retirer puis ajouter » (un ajout reussi apres un retrait rate laissait deux
     pochettes au panier). */
  function switchVariant(newId) {
    if (!isGift(newId) || busy) return Promise.resolve();
    remember(newId);
    var box = document.querySelector('[data-mda-gift]');
    if (box) box.classList.add('is-busy');
    return sync(false, newId).then(function () { refreshDrawer(); });
  }

  function money(cents) {
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      return window.theme.formatMoney(cents, (window.theme.moneyFormat || cfg.moneyFormat));
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' ' + (cfg.currencySymbol || '€');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function render() {
    var boxes = document.querySelectorAll('[data-mda-gift]');
    if (!boxes.length) return;
    if (!cart) return;

    var g = giftLine();
    var total = eligibleTotal();
    var missing = seuil() - total;
    var pct = Math.max(0, Math.min(100, Math.round((total / seuil()) * 100)));
    var avail = cfg.variants.filter(function (v) { return v.available && v.image; });

    var current = null;
    if (g) avail.forEach(function (v) { if (v.id === g.variant_id) current = v; });
    if (!current) {
      var cid = chosenId();
      avail.forEach(function (v) { if (v.id === cid) current = v; });
    }
    if (!current && avail.length) current = avail[0];

    var thumb = current && current.image ? current.image : cfg.image;
    var html = '';

    if (g) {
      html += '<div class="mda-gift__head">';
      if (thumb) html += '<img class="mda-gift__thumb" src="' + esc(thumb) + '" alt="" width="44" height="44" loading="lazy">';
      html += '<div class="mda-gift__txt"><p class="mda-gift__title">' + esc(cfg.text.unlocked) + '</p>';
      if (current) html += '<p class="mda-gift__sub">' + esc(cfg.text.colorLabel) + ' : <b>' + esc(current.title) + '</b></p>';
      html += '</div></div>';

      if (cfg.allowChoice && avail.length > 1) {
        html += '<div class="mda-gift__swatches" role="group" aria-label="' + esc(cfg.text.colorLabel) + '">';
        avail.forEach(function (v) {
          var on = current && v.id === current.id;
          html += '<button type="button" class="mda-gift__sw" data-mda-gift-variant="' + v.id + '"' +
            ' aria-pressed="' + (on ? 'true' : 'false') + '"' +
            ' aria-label="' + esc(v.title) + '" title="' + esc(v.title) + '">' +
            '<img src="' + esc(v.image) + '" alt="" width="30" height="30" loading="lazy"></button>';
        });
        html += '</div>';
      }
    } else {
      html += '<div class="mda-gift__head">';
      if (thumb) html += '<img class="mda-gift__thumb is-locked" src="' + esc(thumb) + '" alt="" width="44" height="44" loading="lazy">';
      html += '<div class="mda-gift__txt"><p class="mda-gift__title">' +
        esc(cfg.text.locked).replace('||amount||', '<b>' + money(missing) + '</b>') + '</p>';
      html += '<div class="mda-gift__bar"><span style="width:' + pct + '%"></span></div>';
      html += '</div></div>';
    }

    for (var i = 0; i < boxes.length; i++) {
      boxes[i].innerHTML = html;
      boxes[i].classList.remove('is-busy');
      boxes[i].classList.toggle('is-unlocked', !!g);
    }
  }

  /* Redessine le tiroir. A n'appeler QUE sur une vraie mutation du panier :
     build() du theme reemet theme:cart:change, donc rafraichir sans filtre
     bouclerait a l'infini (tiroir qui clignote et ne se ferme plus). */
  function refreshDrawer() {
    window.PresidioPlus.gwpProcessed = true;
    var el = document.querySelector('cart-items');
    if (el && typeof el.getCart === 'function') el.getCart();
    render();
  }

  /* Les evenements de MUTATION du theme portent un detail.source
     ("theme-add-to-cart", "theme-update-cart"). Celui emis a la fin de build()
     n'en a pas : on l'ignore, c'est notre garde anti-boucle. */
  /* MDA 04/11 (tests) : un ajout pendant un passage n'est plus jeté : les passages sont en file (fileSync). */
  function onCartChange(e) {
    var d = (e && e.detail) || {};
    if (!d.source) return;
    sync().then(refreshDrawer);
  }

  /* MDA 04/11 (tests) : code promo ajouté ou retiré = redessin du thème SANS source. On relit le panier partagé
     (window.mdaSurPanier) et on relance un passage seulement s'il a changé depuis notre dernier passage. */
  function signature(c) {
    if (!c) return '';
    return [c.total_price, c.item_count, (c.discount_codes || []).map(function (x) { return x.code + (x.applicable ? '+' : '-'); }).join(',')].join('|');
  }
  if (window.mdaSurPanier) {
    window.mdaSurPanier(function (c) {
      if (!cart || signature(c) === signature(cart)) return;
      sync().then(function (changed) { if (changed) refreshDrawer(); });
    });
  }

  document.addEventListener('theme:cart:change', onCartChange);
  document.addEventListener('mda:offre', function () { sync().then(function (c) { if (c) refreshDrawer(); }); }); // MDA 04/11 : jamais ignoré (file d'attente), sinon l'état de l'offre posé pendant un passage était perdu // MDA 02/11 : offre bijou offert
  document.addEventListener('theme:product:added', render);
  document.addEventListener('theme:cart:update', render);
  document.addEventListener('theme:cart-drawer:open', render);

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mda-gift-variant]');
    if (!b) return;
    e.preventDefault();
    switchVariant(Number(b.getAttribute('data-mda-gift-variant')));
  });

  /* Premier passage : le panier peut deja depasser le seuil (visite precedente).
     On ne redessine le tiroir QUE si on a reellement touche au panier : sinon
     getCart() reconstruit le tiroir pour rien, et ca l'ouvre au chargement. */
  sync(true).then(function (changed) {
    window.PresidioPlus.gwpProcessed = true;
    if (changed) refreshDrawer();
    else render();
  });
})();
